
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Link } from 'react-router-dom';

import ResultRadarChart from './ResultRadarChart';
import ResultsInterpretation from './ResultsInterpretation';
import RecommendationsSection from './RecommendationsSection';
import BigFiveAdvancedAnalysisSection from './BigFiveAdvancedAnalysisSection';
import EnhancedAdvancedAnalysisModal from './EnhancedAdvancedAnalysisModal';

interface BigFiveTestResultsProps {
  testResults: any;
  savedResultId: string | null;
  showAnalysisModal: boolean;
  selectedAnalysis: any;
  selectedInsight: any;
  onResetTest: () => void;
  onAnalysisComplete: (analysis: any, insight: any) => void;
  onCloseAnalysisModal: () => void;
}

export default function BigFiveTestResults({
  testResults,
  savedResultId,
  showAnalysisModal,
  selectedAnalysis,
  selectedInsight,
  onResetTest,
  onAnalysisComplete,
  onCloseAnalysisModal
}: BigFiveTestResultsProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-10"
    >
      <div className="text-center max-w-3xl mx-auto mb-8">
        <h1 className="text-3xl font-bold mb-2">Seus Resultados de Personalidade</h1>
        <p className="text-gray-600">
          Baseado em suas respostas, aqui está um perfil dos seus traços de personalidade segundo o modelo Big Five.
        </p>
      </div>
      
      <Card className="p-6">
        <h2 className="text-2xl font-bold mb-6">Seu Perfil</h2>
        <ResultRadarChart scores={testResults.scores} />
      </Card>
      
      <ResultsInterpretation percentiles={testResults.percentiles} />
      
      <RecommendationsSection percentiles={testResults.percentiles} />
      
      {savedResultId && (
        <BigFiveAdvancedAnalysisSection
          savedResultId={savedResultId}
          testResults={testResults}
          onAnalysisComplete={onAnalysisComplete}
        />
      )}
      
      <div className="flex justify-center gap-4 pt-4">
        <Button onClick={onResetTest} variant="outline">
          Fazer Teste Novamente
        </Button>
        <Link to="/app">
          <Button>
            Voltar para o Dashboard
          </Button>
        </Link>
      </div>

      {showAnalysisModal && selectedAnalysis && selectedInsight && (
        <EnhancedAdvancedAnalysisModal
          isOpen={showAnalysisModal}
          onClose={onCloseAnalysisModal}
          analysis={selectedAnalysis}
          insight={selectedInsight}
        />
      )}
    </motion.div>
  );
}
